import DOMPurify from "dompurify";
import HNClientInstance, {IComment, ILoadedCommentTree} from "../util/HnClient";
import {useState} from "react";
import {timeFromNow} from "../util/TimeUtil";

interface IProps {
  comment: ILoadedCommentTree
}

const Comment = ({comment}: IProps) => {
  const [expanded, setExpanded] = useState(true)

  return (

      <div className="comment">
        <div className="commentByLine" onClick={() => setExpanded(!expanded)}>
          <span className="commentByLine__by">{comment.by} {timeFromNow(comment.time)}</span>
        </div>
        {expanded &&
            <>
            <div className="commentText" dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(comment.text)}}></div>
            <div className="commentChildren">
              {comment.loadedKids?.length && comment.loadedKids.map(comment => {
                return (
                    <Comment key={comment.id} comment={comment}/>
                )
              })}
            </div>
            </>
         }

      </div>

  )
}

export default Comment